<template>

    <modal-container>

        <div>

            <!-- Top navbar -->
            <modal-header
                :title="'Shopping status'"
                :right="'close-dark'"
                :noIcon="true">
            </modal-header>

            <template>

                <!-- Loading animation -->
                <lottie class="loading-animation" :options="{animationData: $root.loadAnimation}" v-if="initLoad"/>

                <!-- Prompt content -->
                <prompt-div v-if="!initLoad">

                    <!-- Layout body -->
                    <template v-slot:body>

                        <!-- Product image -->
                        <div class="product-image-section d-flex position-relative mt-4">
                            <div class="card-image-container d-flex justify-content-center m-auto">
                                <img class="card-image img img-fluid" :src="'/image/' + productImage" @error="$root.imageAlt" alt="" />
                            </div>
                        </div>

                        <div class="pt-6">
                            <h3 class="font-lg font-weight-bolder">You have already placed an order for another product</h3>
                            <h4 class="font-md mt-5">You need to finish or cancel your existing order of {{ product.productName }}.</h4>
                        </div>

                        <button class="btn btn-md btn-inverted text-primary px-7 mt-6" @click="continueOrder()">
                            Finish existing order
                        </button>

                        <div class="bottom-bar-buffer"></div>
                        <div class="fixed-bottom full-width bg-white font-sm text-gray-dk py-4 px-7">
                            If you choose not to pickup the item, your order will be automatically cancelled 7 days from applying.
                        </div>

                    </template>

                </prompt-div>

            </template>

        </div>

    </modal-container>

</template>

<script>
    export default {
        data: function() {
            return {
                initLoad: true,
                animationData: require('../../assets/mpl-merchant.json'),
                product: {},
            }
        },

        computed: {
            productImage: function() {
                return this.product.imageId? this.product.imageId[0] : 0
            },
        },

        created: function() {
            let data = this.$store.state.session.noticeDetails.data
            axios
                .get("product/" + data.prevProductId)
                .then(response => {
                    this.initLoad = false
                    this.product = response.data['product']
                })
        },

        methods: {

            continueOrder() {
                let details = this.$store.state.session.noticeDetails

                window.location.replace("exit?location=" + details.redirect);
            },

        }

    }
</script>
